export const StatusCode = {
  Unauthorized: 401,
  Forbidden: 403,
  Timeout: 504,
};
